import { serialize } from 'object-to-formdata';

const ANSWER_KEYS = ['custom_field_values_attributes', 'ticket_custom_field_values_attributes'];

export const requestBodyWithFiles = (rootKey, params) => {
  const hasFile = ANSWER_KEYS.some((key) => (params[key] || []).some((attrs) => attrs.uploaded_file instanceof File));
  if (!hasFile) {
    return { [rootKey]: params };
  }

  const indexed = Object.fromEntries(ANSWER_KEYS.filter((key) => params[key])
    .map((key) => [key, Object.fromEntries(params[key].map((attrs, index) => [index, attrs]))]));

  return serialize({
    [rootKey]: { ...params, ...indexed }
  }, { indices: false, allowEmptyArrays: true });
};

export default requestBodyWithFiles;
